/**
 * Detect if running inside Android App WebView or X5 kernel.
 * In these environments, input[type=file] with capture=camera often fails to show camera;
 * offering explicit "camera" vs "album" entry points improves fallback.
 */
export function isAppOrX5WebView(): boolean {
  if (typeof window === 'undefined') return false;
  if ((window as any).__MUYI_APP__ === true) return true;
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua) && /wv|WebView|QBWebView|TBS|x5/i.test(ua)) return true;
  return false;
}
